import { NextPage } from 'next';

import SsoSelfJoinRedirect from '../components/_organisms/Auth/SsoSelfJoinRedirect';
import { ssoSelfJoinServerSideProps } from '../utils/ssoSelfJoinSsr';

const FeideLogin: NextPage<{ newAuth: boolean }> = ({ newAuth }) => (
  <SsoSelfJoinRedirect
    newAuth={newAuth}
    newProvider="feide"
    azureProvider="azure-ad-b2c-feide-self-join"
    domainHint="feide.no"
  />
);

export const getServerSideProps = ssoSelfJoinServerSideProps;

export default FeideLogin;
